import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { INSTITUTION_ASSETS } from "../../../../s3-assets/Institution";

export const InstitutionCarousel = () => {
  const admissionImages = Object.values(INSTITUTION_ASSETS.ADMISSION_IMAGES);

  return (
    <Carousel
      showThumbs={false}
      autoPlay
      infiniteLoop
      interval={5000}
      showStatus={false}
      showIndicators={true}
      transitionTime={700}
      className="w-full h-screen"
    >
      {admissionImages.map((image, index) => (
        <div key={index} className="relative w-full h-screen">
          <img
            src={image}
            alt={`Slide ${index + 1}`}
            className="w-full h-full object-cover"
          />
          {index === 0 && (
            <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 text-white font-bold text-xl sm:text-2xl">
              Welcome to Our Institution
            </div>
          )}
        </div>
      ))}
    </Carousel>
  );
};